import { render, staticRenderFns } from "./PrivacyAccessHistoriesIframe.vue?vue&type=template&id=30891e84&"
import script from "./PrivacyAccessHistoriesIframe.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAccessHistoriesIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports